module.exports = __webpack_public_path__ + "fonts/avenir-next-demi.5020e73.woff";


//////////////////
// WEBPACK FOOTER
// ./static/fonts/AvenirNext/avenir-next-demi.woff
// module id = 178
// module chunks = 245 246